import { getNetworkedEntity } from "../utils/scene-graph";

AFRAME.registerComponent("hide-when-pinned-and-forbidden", {
  schema: {
    // Hide regardless of being forbidden.
    whenPinned: { type: "boolean" }
  },
  init() {
    this._updateUI = this._updateUI.bind(this);
    this._updateUIOnStateChange = this._updateUIOnStateChange.bind(this);
    this.el.sceneEl.addEventListener("stateadded", this._updateUIOnStateChange);
    this.el.sceneEl.addEventListener("stateremoved", this._updateUIOnStateChange);
    this.el.object3D.visible = false;

    getNetworkedEntity(this.el).then(networkedEl => {
      this.targetEl = networkedEl;

      this._updateUI();
      this.targetEl.addEventListener("pinned", this._updateUI);
      this.targetEl.addEventListener("unpinned", this._updateUI);
      this.targetEl.addEventListener("locked", this._updateUI);
      this.targetEl.addEventListener("unlocked", this._updateUI);
    });
  },

  remove() {
    this.el.sceneEl.removeEventListener("stateadded", this._updateUIOnStateChange);
    this.el.sceneEl.removeEventListener("stateremoved", this._updateUIOnStateChange);

    if (this.targetEl) {
      this.targetEl.removeEventListener("pinned", this._updateUI);
      this.targetEl.removeEventListener("unpinned", this._updateUI);
    }
  },

  _updateUIOnStateChange(e) {
    if (e.detail !== "frozen") return;
    this._updateUI();
  },

  _updateUI() {
    if (!this.targetEl) return;
    const isPinned = this.targetEl.components.pinnable && this.targetEl.components.pinnable.data.pinned;
    const isLocked = this.targetEl.components.lockeable && this.targetEl.components.lockeable.data.locked;
    const previousVisibility = this.el.object3D.visible;

    if (this.data.whenPinned) {
      this.el.object3D.visible = !isPinned;

      if (isLocked) {
        this.el.object3D.visible = !isLocked;
      }
    } else {
      const pinnedAndForbidden = isPinned && !window.APP.hubChannel.canOrWillIfCreator("pin_objects");
      this.el.object3D.visible = !pinnedAndForbidden;
    }

    if (previousVisibility !== this.el.object3D.visible) {
      this.el.emit("visibilitychange", { visible: this.el.object3D.visible });
    }
  }
});
